import { emitter } from '../event';
import { downLoadCheck } from './downLoad';
import { useUserStore } from '@/store/user';
import { urlCheck } from '@/hooks/UrlCheck';
import { useStatusStore } from '@/store/status';
import { useSystemStore } from '@/store/system';
import { useChannelStore } from '@/store/channel';
import { BROWSER, SD_MODEL } from '@/enums/device';
import { showIosPwaGuideModal } from './showIosGuide';
import { getDeferredPrompt } from '@/utils/pwa/deferredPrompt';

/**
 * @description 安装检测
 * @param modal 是否弹窗安装
 */
export async function installCheck(modal?: boolean) {
  const userStore = useUserStore();       // 用户信息
  const systemStore = useSystemStore();   // 系统信息
  const statusStore = useStatusStore();   // 状态信息
  const channelStore = useChannelStore(); // 渠道信息

  if (userStore.user?.id) {
    emitter.emit('user/download', {
      userId: userStore.user.id,
    })
  }
 
  channelStore.setInstallStatus(0);

  if (systemStore.browser === BROWSER.MOBILE_SAFARI) {
    if (channelStore.promotionInfo?.installType === 'DESK') {
      showIosPwaGuideModal();
    } else {
      location.href = urlCheck(channelStore.promotionInfo?.installUrl);
    }
  } else {
    if (channelStore.promotionInfo?.installType === 'APK') {
      location.href = urlCheck(channelStore.promotionInfo?.installUrl);
    } else {
      const deferredPrompt = getDeferredPrompt();
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        if (systemStore.app?.build === SD_MODEL.ANDROID_H5) {
          localStorage.setItem("webAppInstalled", 'true');
          channelStore.setInstallStatus(1); // 无论是否弹窗安装，都设置正在安装状态(强制弹窗无需弹窗安装，但也需要设置状态)
          if (modal) {
            statusStore.setHomeInstallModalVisible(true);
          }
        }
      } else {
        if (channelStore.promotionInfo?.installType === 'PWA+APK' && systemStore.app?.build === SD_MODEL.ANDROID_H5) {
          downLoadCheck();
        }
      }
    }
  }
}